 <!-- My Profile -->
 <div class="profile">
    <div class="row">
        <div class="col-md-12 mb-4">
            
            <div class="user-img mx-auto">
                <img src="imgs/erwaa-١٥.png" alt="" class="img-fluid img-contain">
            </div>
            
        </div>
        <div class="col-md-12 mb-4">
            
            <div class="user-info bg-main-color p-4">
                <div class="user-name text-uppercase py-4 border-bottom">
                    <span class="text-white"><i class="fas fa-pencil-alt"></i> name</span>
                    <span class="float-right text-secondary-color">{{currentUser.name}}</span>
                </div>
                <div class="user-phone text-uppercase py-4 border-bottom">
                    <span class="text-white"><i class="fas fa-pencil-alt"></i> phone</span>
                    <span class="float-right text-secondary-color">{{currentUser.phone}}</span>
                </div>
                <div class="user-email text-uppercase py-4 border-bottom">
                    <span class="text-white"><i class="fas fa-pencil-alt"></i> email</span>
                    <span class="float-right text-secondary-color">{{currentUser.email}}</span>
                </div>
                <div class="user-country text-uppercase py-4 ">
                    <span class="text-white"><i class="fas fa-pencil-alt"></i> country</span>
                    <span class="float-right text-secondary-color">{{currentUser.country.name_en}}</span>
                </div>
            </div>
            
        </div>
        
    </div>

</div>
<!-- ./My Account -->